import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Component, Input, OnInit, ViewChild, ElementRef, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

declare function require(name: string);
const flatpickr = require('flatpickr');
const confirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');


@Component({
  selector: 'app-single-date-picker',
  templateUrl: './single-date-picker.component.html',
  styleUrls: ['./single-date-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SingleDatePickerComponent implements OnInit {

  @Input()
  public startFormControl: FormControl;

  @Input()
  public disableCalendar = false;

  @Output()
  public modelChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('inputBox' ,{static: true}) public inputBox: ElementRef;

  public flatPickerInstance: any;

  private dateTimeWithTZ: any;

  constructor() {
  }

  ngOnInit() {
    if (!this.startFormControl) {
      this.startFormControl = new FormControl(null);
    }

    const datePickerComponent = this;
    const defaultStartTime = this.startFormControl.value ? moment(this.startFormControl.value).format('YYYY-MM-DD hh:mm:ss A') : null;

    this.flatPickerInstance = flatpickr('input[data-input-type=start].date-field-width', {
      mode: 'single',
      enableTime: true,
      enableSeconds: true,
      dateFormat: 'm/d/Y G:i:S K',
      minuteIncrement: 1,
      onOpen: [
        (selectedDates /*start date*/, dateStr, instance) => {
          // maxDate can be either end date or 'today'
          // minDate should be moment().add(-90, 'day').toDate()
          if (!this.startFormControl.value) {
            instance.clear();
          } else {
            instance.set('defaultDate', moment(this.startFormControl.value, 'MM/DD/YYYY hh:mm:ss A'));
          }

          instance.set('enable', [(date) => {
            return moment(date).isBefore(moment()) && moment(date).isAfter(moment().add(-90, 'day')) ? true : false;
          }]);
        }
      ],
      onValueUpdate: (date) => {
        if (date[0]) {
          if (moment(date[0]).isBefore(moment()) && moment(date[0]).isAfter(moment().add(-90, 'day'))) {
            datePickerComponent.startFormControl.setValue(
              moment(date[0]).format('MM/DD/YYYY hh:mm:ss A')
            );
            this.dateTimeWithTZ = date[0];
          } else {
            datePickerComponent.startFormControl.setValue(null);
            this.dateTimeWithTZ = null;
          }
        }
      },
      onClose() {
        const timer: Subscription = TimerObservable.create(0, 10).subscribe(
          () => {
            datePickerComponent.onChange();
            timer.unsubscribe();
          }
        );
      },
      onReady() { this.showTimeInput = true },
      defaultDate: defaultStartTime,
      "plugins": [new confirmDatePlugin({showAlways: true})]
    });
  }

  public clear() {
    if (this.flatPickerInstance) {
      this.flatPickerInstance.clear();
    }
  }

  private onChange() {
    const startDate = this.startFormControl.value;
    this.modelChange.emit({
      date: startDate,
      dateTimeWithTZ: this.dateTimeWithTZ
    });
  }
}
